<template>
  <protocol-dialog :sign="sign" :close-btn="closeBtn" @disagree="disAgree" @agree="agree" @close="close" >
    <div v-if="showTip" slot="title" class="warn-desc" style="color: red;">
      <p style="text-align: center;">关于线上合作协议主体变更的通知</p>
      <p>尊敬的用户：</p>
      <p>我们特此通知您，根据公司业务发展的需要，我们的线上合作协议主体将发生变更。变更主体后的收款账户信息您可前往【财务管理-充值申请】查看。原协议中的权利和义务由变更后主体继续履行，双方的权利和义务保持不变。您在原主体的现金账户余额在退款前由原主体提供服务。如有任何问题，请随时与我们联系。</p>
      <br/>
      <p>请您仔细阅读后点击“同意”完成本次变更事宜。</p>
    </div>
    <iframe :src="protocolUrl"></iframe>
  </protocol-dialog>
</template>
<script>
  import ProtocolDialog from './protocol-dialog.vue';
  import axios from 'common/axios.js';
  const ACCEPT_URL = {
    '4': '/v2/account/core/agreeProtocol',
    '2': '/v2/account/agent/agreeProtocol',
    '1': '/v2/account/agreeProtocol'
  };
  const ACCOUNT_TYPE = {
    '4': 'core',
    '2': 'agent',
    '1': 'customerId'
  }
  export default {
    name: 'platform-dialog',
    components: {
      ProtocolDialog
    },
    props: {
      sign: Boolean,
      closeBtn: Boolean,
      id: [Number, String],
      accountType: [Number, String],
      protocolUrl: String,
      protocolName: String,
      showTip: Boolean
    },
    computed: {
      accountTypeStr() {
        return this.accountType + '';
      }
    },
    methods : {
      close() {
        this.$emit('close');
      },
      disAgree () {
        this.$emit('disagree'); 
        window.location.href = '/account/logout';
      },
      async agree() {
        let pdata = {
          protocolName: this.protocolName
        }
        if (ACCOUNT_TYPE[this.accountTypeStr]) {
          pdata[ACCOUNT_TYPE[this.accountTypeStr]] = this.id;
        }
        try {
          await axios({
            url: ACCEPT_URL[this.accountTypeStr],
            method: 'post',
            data: pdata,
            customError: () => {
              this.$emit('agree');
            }
          });
          this.$emit('agree');
        } catch (e) {
          console.log(e)
          this.$alert(e.failMsg);
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  .bold {
    font-weight: bold;
  }
  .section {
    h3 {
      padding : 10px 0;
      font-size : 16px !important;
    }
    table {
      margin-left : 40px;
      th {
        background : #f9f9f9;
        font-weight: bold;
      }
      th, td {
        border:1px solid #ddd; 
      }
    }
    ol > li {
      img {
        width : 30px;
      }
    } 
    ol > li > p {
      padding-left : 15px;
      
    }
    ol > li > ul {
      padding-left : 15px;
    }
    ol > li > ul > li > ul {
      padding-left : 15px;
    }
  }
  .warn-desc {
    font-size: 12px;
    text-align: left;
    line-height: 20px;
  }
  .inner-title {
    font-size: 16px;
    text-align: center;
    height: 80px;
    line-height: 80px;
    padding: 30px 50px 0;
  }
</style>
